import { IPaymentCardValues, ESupplierBusinessCode } from '@origin-digital/payments';
import {
  IDivisionCode,
  IContractStatus,
  IServiceType,
} from '@origin-digital/shared-app-context/dist/typings/generated/api/models';
import { IContractAccountInvoice } from '@origin-digital/payment-service-dapi-contract';

declare global {
  // eslint-disable-next-line @typescript-eslint/interface-name-prefix
  interface Window {
    grecaptcha: {
      execute?(): void;
      getValue?(): string;
    };
    MutationObserver: any;
  }
}

export interface IContractAccountBalanceWithSacInfo extends IContractAccountInvoice {
  divisionCode?: IDivisionCode;
  type?: IServiceType;
  status: IContractStatus;
}

export type IPaymentData = IPaymentCardValues;

export enum EPaymentType {
  PaymentScheme = 'PAYMENTSCHEME',
  Invoice = 'INVOICE',
}

export interface ICustomerDataResponse {
  retreivedAccounts: ILPGRetrievedAccounts[];
}

export interface ILPGRetrievedAccounts {
  CustomerNumber: string;
  AccountBalance: number;
}

export interface IKrakenPayData {
  amount: number;
  single_use_token: string;
  captcha_token: string;
  electronic_commerce_indicator: 'INTERNET';
  supplier_business_code: ESupplierBusinessCode.RetailX;
}

export interface IKrakenPayResponse {
  amount: number;
  payment_date: string;
  reference: string;
}

export enum AccountBackend {
  kraken = 'K',
  sap = 'S',
}

export interface IAccountTypeResponse {
  backend: AccountBackend;
  customerType: 'SME' | 'RESIDENTIAL';
}
